// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-header[data-v-428a895e]{margin-bottom:10px}.input-header .popover-icon[data-v-428a895e]{position:absolute;color:var(--q4s-accent);right:0;top:3px;cursor:pointer}.select_space_label[data-v-428a895e]{position:relative;color:var(--q4s-neutral-750);font-style:normal;font-weight:500;font-size:16px;line-height:22px}.select_space_label .required[data-v-428a895e]{color:var(--q4s-danger-500);position:absolute;left:-16px;top:0;z-index:2;font-size:16px}", ""]);
// Exports
module.exports = exports;
